export const ALL_CATEGORIES_ID = 'ALL_CATEGORIES_ID';
export const ALL_SHOPS_ID = 'ALL_SHOPS_ID';
export const STORAGE_KEY_REMOVING_DELAY = 1000;
